import React, { Fragment, useState, createContext, Suspense } from "react";
import { Outlet } from "react-router-dom";
import Menu from "./components/Menu";
import { Preloader } from "@components";

export const MobileContext = createContext();

const MobileLayout = ({ children }) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <MobileContext.Provider value={{ showMenu, setShowMenu }}>
      <Fragment>
        <Menu showMenu={showMenu} setShowMenu={setShowMenu} />
        <div className="h-100 w-100">
          <Suspense fallback={<Preloader />}>
            <Outlet />
          </Suspense>
        </div>
        {/* 可選的附加元件，例如 RedirectOnMobile */}
        {children}
      </Fragment>
    </MobileContext.Provider>
  );
};

export default MobileLayout;
